import {
  Action,
  ActionType,
  BodyTemperatureSettingFormResponse,
} from "models/bodyTemperature/settingForm";
import createReducer from "../../createReducer";

export interface BodyTemperatureSettingFormReducerType {
  loading: boolean;
  error?: string;
  bodyTemperatureSettingFormResponse?: BodyTemperatureSettingFormResponse;
}

const defaultState: BodyTemperatureSettingFormReducerType = {
  loading: false,
  error: undefined,
  bodyTemperatureSettingFormResponse: undefined,
};

export const getBodyTemperatureSettingFormDataReducer =
  createReducer<BodyTemperatureSettingFormReducerType>(defaultState, {
    [ActionType.BODY_TEMPERATURE_SETTING_FORM_DATA](
      state: BodyTemperatureSettingFormReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.BODY_TEMPERATURE_SETTING_FORM_DATA_ERROR](
      state: BodyTemperatureSettingFormReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.BODY_TEMPERATURE_SETTING_FORM_DATA_SUCCESS](
      state: BodyTemperatureSettingFormReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        bodyTemperatureSettingFormResponse: action.payload,
      };
    },
  });
